// removed by extract-text-webpack-plugin
module.exports = {"mobile-back-wrapper":"main_nav-1fS","mobile-back":"main_nav-3Id","mobile-back-click":"main_nav-3OF","mobile-back-icon":"main_nav-164"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/MobileBack/mobile_back.module.scss
// module id = 359
// module chunks = 0